``

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppFormsNavigator } from './app-forms-navigator';
//import { LayoutComponent } from './pages/_layout/layout.component'; 

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'client/forms',
    component: AppFormsNavigator
    //loadChildren: () =>
    //  import('./modules/medicaid-review-form/medicaid-review-form.module').then((m) => m.MedicaidReviewFormModule),
  },
  {
    path: 'client/forms/470_5168',
    loadChildren: () =>
      import('./modules/medicaid-review-form/medicaid-review-form.module').then((m) => m.MedicaidReviewFormModule),
  },

  //{
  //  path: 'Medicaid',
  //  component: LayoutComponent,

  //  loadChildren: ()=>
  //    import('./modules/medicaid-review-form/medicaid-review-form.module').then((m) => m.MedicaidReviewFormModule),
  //  data: { preload: true, delay: 5000 }
  //},
  //{
  //  path: 'MedicaidStateSsup',
  //  component: LayoutComponent,

  //  loadChildren: () =>
  //    import('./modules/medicaid-state-ssup-review-form/medicaid-state-ssup-review-form.module').then((m) => m.MedicaidStateSsupReviewFormModule),
  //  data: { preload: true, delay: 5000 }
  //},
  {
    path: 'client/forms/470_5482',
    loadChildren: () =>
      import('./modules/medicaid-state-ssup-review-form/medicaid-state-ssup-review-form.module').then((m) => m.MedicaidStateSsupReviewFormModule),
  },
  {

    path: 'public/dsnap',
    loadChildren: () =>
      import('./modules/dsnap/dnsap.module').then((m) => m.DSNAPModule),
    data: { preload: true, delay: 5000 }
  },
  //{

  //  path: 'dsnap',
  //  component: LayoutComponent,
  //  loadChildren: () =>
  //    import('./modules/dsnap/dnsap.module').then((m) => m.DSNAPModule), 
  //  data: { preload: true, delay: 5000 }
  //},
  {
    path: 'Public/DSNAP',
    loadChildren: () =>
      import('./modules/dsnap/dnsap.module').then((m) => m.DSNAPModule),
    data: { preload: true, delay: 5000 }
  },
  {
    path: 'rent-reimbursement',
    loadChildren: () =>
      import('./modules/rent-reimbursement/rent-reimbursement.module').then((m) => m.RentReimbursementModule),
    data: { preload: true, delay: 5000 }
  },
  {
    path: 'apply/sunbucks',
    loadChildren: () =>
      import('./modules/sun-bucks/sun-bucks.module').then((m) => m.SunBucksModule),
    data: { preload: true, delay: 5000 }
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'program/dsnap',
    loadChildren: () =>
      import('./modules/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'program/rentreimbursement',
    loadChildren: () =>
      import('./modules/landing/landing.module').then((m) => m.LandingModule),
  },
  //{
  //  path: 'dashboard',
  //  //canActivate: [AuthGuard],
  //  loadChildren: () =>
  //    import('./pages/layout.module').then((m) => m.LayoutModule),
  //},
  {
    path: 'client',
    loadChildren: () =>
      import('./modules/client/client.module').then((m) => m.ClientModule),
  },
  {
    path: 'client/forms/470_5590',
    loadChildren: () =>
      import('./modules/report-a-change-form/report-a-change-form.module').then((m) => m.ReportAChangeFormModule),
  },
  //{
  //  path: 'Medicaid',
  //  component: LayoutComponent,
  //  loadChildren: () =>
  //    import('./modules/report-a-change-form/report-a-change-form.module').then((m) => m.ReportAChangeFormModule),
  //  data: { preload: true, delay: 5000 }
  //},
  { path: '**', redirectTo: 'error/404' },
];
const isIframe = window !== window.parent && !window.opener;
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled',
    // Scroll to top automatically on every navigation — implemented once globally.
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
